module.exports = __webpack_public_path__ + "img/quote.52450459.svg";